module.exports = __webpack_public_path__ + "img/Logo-15.8500fb11.svg";